import http from '@/api/base'

const settingadd = (params) => {
  // params.test = true
  return http.post('/portal/ewallet/recharge-setting/add', params)
}
const settingedit = (params) => {
  // params.test = true
  return http.post('/portal/ewallet/recharge-setting/update', params)
}
const settingdel = (params) => {
  // params.test = true
  return http.post('/portal/ewallet/recharge-setting/delete', params)
}
const settingget = (params) => {
  // params.test = true
  return http.post('/portal/ewallet/settingget', params)
}
const pageEwalletSetting = (params) => {
  // params.test = true
  return http.post('/portal/ewallet/recharge-setting/list', params)
}
const updateEwalletSettingSort = (params) => {
  // params.test = true
  return http.post('/portal/ewallet/recharge-setting/sort', params)
}

// 企业订单分页查询
const orderList = (params) => {
  return http.post('/portal/subsidy/order/list', params)
}
// 根据id 查详情
const orderQuery = (params) => {
  return http.post('/portal/subsidy/order/query', params)
}
// 删除企业订单
const orderDelete = (params) => {
  return http.post('/portal/subsidy/order/delete', params)
}
// 余额管理分页查询
const balanceList = (params) => {
  return http.post('/portal/subsidy/wallet/enterprise/balanceList', params)
}
// 余额管理查询总额
const enterpriseBalanceList = (params) => {
  return http.post('/portal/subsidy/wallet/enterprise/balanceList', params)
}
// 查询公司部门
const departmentBook = (params) => {
  return http.post('/portal/department/departmentBook', params)
}
// 提现次数设置
const setWithdrawalQuantity = (params) => {
  return http.post(`/portal/enterprise/pay/setAppWithdrawalConfig`, params)
}
// 提现次数设置查询
const queryWithdrawalQuantity = (params) => {
  return http.post('/portal/enterprise/pay/queryAppWithdrawalConfig', params)
}

// 提现管理--提现手续费设置
const getFeeConfig = (params) => {
  return http.post(`/portal/withdraw/fee/config/detail`, params)
}
const saveFeeConfig = (params) => {
  return http.post(`/portal/withdraw/fee/config/saveDetail`, params)
}
// 提现管理--商户列表
const getMerchantList = (params) => {
  return http.post(`/portal/pay-merchant/list`, params)
}
// 查询手续费配置列表（交易手续费）
const transactionFeeList = (params) => {
  return http.post(`/portal/withdraw/fee/config/transactionFeeList`, params)
}
// 提现管理--营业抽成设置
const getFeeConfigList = (params) => {
  return http.post(`/portal/withdraw/fee/config/list`, params)
}
// 提现管理--交易手续费设置
const transactionFee = (params) => {
  return http.post(`/portal/enterprise/pay/transactionFee`, params)
}
// 保存交易手续费
const saveDetailList = (params) => {
  return http.post('/portal/withdraw/fee/config/saveDetailList', params)
}
// 商户提现时间设置
const getVerbList = (params) => {
  return http.post('/portal/withdraw/config/list', params)
}
const configMerchantWithdraw = (params) => {
  return http.post('/portal/withdraw/config/configMerchantWithdraw', params)
}
// 按条件查询分页数据 商户折扣
const discountList = (params) => {
  return http.post('/portal/pay-merchant-discount/list', params)
}
// 新增 商户折扣
const discountAdd = (params) => {
  return http.post('/portal/pay-merchant-discount/add', params)
}
// 更新 商户折扣
const discountUpdate = (params) => {
  return http.post('/portal/pay-merchant-discount/update', params)
}
// 删除 商户折扣
const discountDelete = (params) => {
  return http.post('/portal/pay-merchant-discount/delete', params)
}
export default {
  departmentBook,
  setWithdrawalQuantity,
  queryWithdrawalQuantity,
  balanceList,
  enterpriseBalanceList,
  orderQuery,
  orderDelete,
  orderList,
  settingadd,
  settingedit,
  settingdel,
  settingget,
  pageEwalletSetting,
  updateEwalletSettingSort,
  getFeeConfig,
  saveFeeConfig,
  getMerchantList,
  transactionFeeList,
  getFeeConfigList,
  transactionFee,
  saveDetailList,
  getVerbList,
  configMerchantWithdraw,
  discountList,
  discountAdd,
  discountUpdate,
  discountDelete
}



// WEBPACK FOOTER //
// ./src/area-apartment/api/eWalletService.js